import styled from 'styled-components';
import {AccentColorOptions} from 'epic-ue-theme';

export const NewsletterCardWrapper = styled.div<{
    paddingBottom: string;
    accentColor: AccentColorOptions;
}>`
    & {
        .ue-outlined-card {
            display: block;
            max-width: 416px;
            text-align: center;
            padding: 48px 48px calc(48px - ${(p) => p.paddingBottom}) 48px;

            ${(p) => p.theme.breakpoints.down('sm')} {
                padding: 24px 24px calc(24px - ${(p) => p.paddingBottom}) 24px;
            }
        }

        .heading.h3 {
            overflow: unset;
        }

        .eyebrow-wrapper {
            color: ${(p) => p.theme.palette.text.secondary};
        }

        .paragraph.caption {
            color: ${(p) =>
                p.theme.ifLight(p, 'theme.palette.neutral.steel', 'theme.palette.neutral.stone')};
        }

        .icon-button-root {
            transition: color 0.2s ${(p) => p.theme.easing};
            transition: transform 0.2s ${(p) => p.theme.easing};
            padding: 0;
            margin-right: 4px;
            &:focus-visible {
                outline: 1px solid ${(p) => p.theme.palette.misc.outline};
                outline-offset: -1px;
                background: unset;
                box-shadow: unset;
            }
            &:hover {
                background: unset;
                transform: translateX(4px);
                color: ${(p) => p.theme.palette.accent[p.accentColor]};
            }
        }

        .ue-icon-check {
            font-size: 42px;
        }
    }
`;
